import { memo } from 'react';
import { EditableCell } from './EditableCell';
import { ProjectDateCellContent } from './ProjectDateCellContent';
import type { Project } from '@/api/client';
import { getBaseStatus } from '@/utils/projectStatuses';

interface DeadlineCellProps {
  project: Project;
  searchHighlightWords?: string[];
}

const EmptyValue = () => <span className="projects-table__empty-value">N/A</span>;

export const DeadlineCell = memo(function DeadlineCell({ project, searchHighlightWords }: DeadlineCellProps) {
  const hasData = project.deadline?.trim();
  const display = hasData ? (
    <ProjectDateCellContent
      dateStr={project.deadline}
      isCompleted={getBaseStatus(project.state) === 'Готов'}
      todayLabel="Дедлайн сегодня"
      containerClassName="projects-table__deadline-cell"
      searchHighlightWords={searchHighlightWords}
    />
  ) : (
    <EmptyValue />
  );

  return (
    <EditableCell project={project} fieldKey="deadline">
      {display}
    </EditableCell>
  );
});
